import React from "react";
import './Termsandcondition.css';


const TermsAndcondition = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions for Fusshn</h1>
      
      <p>
        Thank you for choosing Fusshn! These Terms and Conditions (“Terms”) are essential in outlining the expectations for both users and our platform. By using Fusshn, you agree to these Terms, so please read them thoroughly.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By downloading, installing, or using Fusshn, you confirm that you agree to these Terms and are legally capable of entering into this agreement. If you do not accept any part of these Terms, please refrain from using Fusshn.
      </p>

      <h2>2. User Accounts</h2>
      <p>
        <strong>Eligibility:</strong> You must be at least 18 years old to use Fusshn. Minors (under 18) may use Fusshn only under the supervision of a legal guardian.
      </p>
      <p>
        <strong>Registration:</strong> To access certain features, you will need to create an account. You agree to provide accurate and current information and to update it promptly if any changes occur.
      </p>
      <p>
        <strong>Account Responsibility:</strong> You are solely responsible for all activities that occur under your account, including maintaining the security of your login information. Fusshn is not liable for any unauthorized access to your account.
      </p>

      <h2>3. Ticket Purchases and Payments</h2>
      <p>
        <strong>Ticket Sales:</strong> Fusshn acts as an intermediary between you and event organizers, facilitating ticket sales. Ticket prices and availability are controlled by the event organizers.
      </p>
      <p>
        <strong>Pricing:</strong> Ticket prices are displayed at checkout and may include service fees, booking charges, or taxes. All prices are final and may vary depending on the event, location, or demand.
      </p>
      <p>
        <strong>Payment Processors:</strong> Payments are securely handled by trusted third-party processors. By purchasing tickets, you agree to the terms and conditions of these processors.
      </p>
      <p>
        <strong>Order Confirmation:</strong> Your order is confirmed only once payment has been successfully processed. You will receive an electronic ticket, which serves as proof of purchase. Fusshn reserves the right to cancel or decline orders in case of payment issues or suspected fraud.
      </p>

      <h2>4. Ticket Use and Access</h2>
      <p>
        <strong>Non-Transferability:</strong> Unless specified, tickets purchased on Fusshn are non-transferable and are strictly for personal use.
      </p>
      <p>
        <strong>Valid Identification:</strong> You may be required to present valid identification along with your ticket to gain entry to events.
      </p>
      <p>
        <strong>Compliance with Event Rules:</strong> Each event may have specific rules, including age restrictions, dress codes, or prohibited items. You agree to abide by these rules as set by the event organizer.
      </p>
      <p>
        <strong>Prohibition on Resale:</strong> Unauthorized resale or attempted resale of tickets is strictly prohibited. Fusshn reserves the right to cancel accounts engaging in resale activities.
      </p>

      <h2>5. Event Cancellations, Changes, and Refunds</h2>
      <p>
        <strong>Event Cancellations:</strong> In case of event cancellation, Fusshn will attempt to notify you promptly via email or app notifications. Refunds or exchanges are subject to the organizer's policy, and Fusshn facilitates these refunds on behalf of the organizer.
      </p>
      <p>
        <strong>Rescheduled Events:</strong> If an event is rescheduled, the original ticket may still be valid for the new date. You are encouraged to verify details with the event organizer.
      </p>
      <p>
        <strong>Refund Policy:</strong> Refunds are only issued per the organizer’s refund policy. Fusshn cannot guarantee refunds beyond the policies set by the event organizer.
      </p>
      <p>
        <strong>Event Modifications:</strong> Fusshn is not responsible for any changes to event details, including time, date, lineup, or venue. It’s advisable to confirm event specifics closer to the date.
      </p>

      <h2>6. User Conduct and Obligations</h2>
      <p>
        <strong>Prohibited Activities:</strong> You agree not to engage in any prohibited activities on Fusshn, including:
      </p>
      <ul>
        <li>Unauthorized commercial use of tickets or listings.</li>
        <li>Attempting to access or modify the app’s source code.</li>
        <li>Using bots, scrapers, or other automated tools to extract data from Fusshn.</li>
      </ul>
      <p>
        <strong>Respectful Behavior:</strong> Users are expected to engage respectfully with event organizers, Fusshn staff, and other users. Discriminatory, offensive, or abusive conduct may result in account suspension or ban.
      </p>
      <p>
        <strong>Reporting Issues:</strong> If you encounter issues with ticketing, event information, or user interactions, please report them to Fusshn's customer support promptly.
      </p>

      <h2>7. Intellectual Property and Content Use</h2>
      <p>
        <strong>Ownership of Content:</strong> All content, including graphics, logos, images, text, and software, is the property of Fusshn or its licensors. Unauthorized use is strictly prohibited.
      </p>
      <p>
        <strong>Limited License:</strong> Fusshn grants you a limited, revocable license to use the app for personal, non-commercial purposes only.
      </p>
      <p>
        <strong>User-Generated Content:</strong> By posting or uploading content to Fusshn (such as reviews or comments), you grant Fusshn a non-exclusive, royalty-free license to use, distribute, or modify the content as part of platform operations.
      </p>

      <h2>8. Data Privacy and Security</h2>
      <p>
        <strong>Data Collection:</strong> Fusshn collects and processes personal information to provide services. By using Fusshn, you agree to our data handling practices as outlined in our Privacy Policy.
      </p>
      <p>
        <strong>Data Security:</strong> We employ measures to protect your information from unauthorized access, but please remember that no platform is completely secure. Fusshn is not liable for data breaches caused by external factors.
      </p>
      <p>
        <strong>User Rights:</strong> You have the right to access, correct, and delete your personal information. For any inquiries about data privacy, please contact Fusshn's support.
      </p>

      <h2>9. Disclaimer of Warranties</h2>
      <p>
        <strong>"As-Is" Basis:</strong> Fusshn is provided "as-is" and "as-available." We do not guarantee uninterrupted, error-free access or that the platform will meet your expectations.
      </p>
      <p>
        <strong>Event Quality:</strong> Fusshn is not responsible for the quality or content of events listed. We only act as a facilitator and do not influence event planning or management.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        <strong>Direct Damages:</strong> To the maximum extent permitted by law, Fusshn's liability is limited to the amount paid for the specific ticket purchase that led to the claim.
      </p>
      <p>
        <strong>No Indirect Damages:</strong> Fusshn is not liable for indirect damages, including loss of opportunity, data loss, or reputational harm resulting from your use of the app.
      </p>
      <p>
        <strong>Third-Party Liability:</strong> Fusshn is not responsible for actions, omissions, or misconduct by event organizers or third-party vendors.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Fusshn, its affiliates, officers, and employees from any claims, damages, or expenses resulting from:
      </p>
      <ul>
        <li>Violation of these Terms.</li>
        <li>Misuse of the platform or services.</li>
        <li>Infringement of third-party rights through your account.</li>
      </ul>

      <h2>12. Modification of Terms</h2>
      <p>
        Fusshn reserves the right to update these Terms as needed. Major updates will be communicated via app notifications or email. Continued use after updates constitutes acceptance of the revised Terms.
      </p>

      <h2>13. Governing Law and Dispute Resolution</h2>
      <p>
        <strong>Applicable Law:</strong> These Terms and any disputes are governed by the laws of [Your Jurisdiction].
      </p>
      <p>
        <strong>Dispute Resolution:</strong> For unresolved disputes, we encourage you to contact Fusshn’s support for informal resolution. Otherwise, disputes may be resolved through arbitration in [Location/Your Jurisdiction].
      </p>

      <h2>14. Feedback and Contact Information</h2>
      <p>
        <strong>Feedback:</strong> We welcome feedback to help improve our platform and services. Any suggestions or comments submitted to Fusshn may be used without restriction.
      </p>
      <p>
        <strong>Contact:</strong> For questions, concerns, or support, reach out to us at:
        <br /> Email: <a href="mailto:fusshn.business@gmail.com">fusshn.business@gmail.com</a>
        
      </p>

      <p className="confirmation">
        By using Fusshn, you confirm that you have read, understood, and agree to these Terms. Thank you for trusting Fusshn to enhance your event experience!
      </p>
    </div>
  );
};

export default TermsAndcondition;














